import {
  BASE_PROJECT_DEVELOPMENT_CONFIG,
  PRELIMINARY_DESIGN,
  ProjectDevelopmentStructure,
  ProjectTypeStructure,
  WORKING_DOCUMENTATION,
} from '../../../components';
import {
  ENGINEERING_SYSTEMS_CDN_PATH,
  ENGINEERING_SYSTEMS_STORAGE_PATH,
} from '../../../engineering-systems-constants';
import {
  HEATING_PRELIMINARY_DESIGN_ID,
  HEATING_WORKING_DOCUMENTATION_ID,
} from '../../heating-systems-constants';

export const HEATING_PROJECT_TYPE_LIST: ProjectTypeStructure[] = [
  {
    ...PRELIMINARY_DESIGN,
    id: HEATING_PRELIMINARY_DESIGN_ID,
    consultationSignup: {
      href: `${ENGINEERING_SYSTEMS_STORAGE_PATH}sistemy-otopleniya-primer-eskiznogo-proekta.pdf`,
      src: `${ENGINEERING_SYSTEMS_CDN_PATH}/features/1.svg/1.svg`,
      label: 'Скачать пример',
    },
  },
  {
    ...WORKING_DOCUMENTATION,
    id: HEATING_WORKING_DOCUMENTATION_ID,
    consultationSignup: {
      href: `${ENGINEERING_SYSTEMS_STORAGE_PATH}sistemy-otopleniya-primer-rabochey-dokumentacii.pdf`,
      src: `${ENGINEERING_SYSTEMS_CDN_PATH}/heating/2.svg/2.svg`,
      label: 'Скачать пример',
    },
    priceUnits: '/м²',
  },
];

export const HEATING_PROJECT_DEVELOPMENT: ProjectDevelopmentStructure = {
  ...BASE_PROJECT_DEVELOPMENT_CONFIG,
  id: HEATING_WORKING_DOCUMENTATION_ID,
  compositionList: WORKING_DOCUMENTATION.compositionList,
  exampleHref: `${ENGINEERING_SYSTEMS_STORAGE_PATH}sistemy-otopleniya-primer-rabochey-dokumentacii.pdf`,
  priceUnits: '/м²',
  schedule: WORKING_DOCUMENTATION.schedule,
};
